var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.titleMessage }, [
    _c(
      "div",
      { class: _vm.$style.wrapper },
      [
        _vm.showIcon
          ? _c("VsIcon", {
              staticClass: "mr-3 mt-1 mt-md-0",
              attrs: { icon: "md:warning" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-left", class: _vm.$style.textContent },
          [
            _vm._t("title", [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("warn-rated-content")) + "\n      "
              )
            ]),
            _vm._v(" "),
            _vm._t("message")
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }